import { action } from 'satcheljs';
import type BookingPrivacyType from '../store/schema/BookingPrivacyType';
/**
 * Action to update the meetingType edit error flag in the store.
 */

const setEditStatePrivacyType = action(
    'setEditStatePrivacyType',
    (privacyType: BookingPrivacyType) => ({
        privacyType,
    })
);

export default setEditStatePrivacyType;
